import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'my-10 w-full scroll-mt-[calc(var(--head-fixed-height-1,172px)+16px)] max-lg:scroll-mt-[calc(var(--head-fixed-height,64px)+16px)] max-md:scroll-mt-[calc(var(--head-fixed-height,48px)+16px)] sm:my-20',
    header: 'mb-10 grid grid-cols-1 lg:grid-cols-2 lg:gap-6',
    tabsContainer:
      'mb-4 flex items-center justify-between lg:col-start-1 lg:row-start-1',
    mobileButton: 'flex size-10 items-center justify-center lg:hidden',
    button:
      'order-4 mt-8 w-full sm:w-60 lg:order-0 lg:col-start-2 lg:row-start-1 lg:mt-0 lg:w-70 lg:justify-self-end',
    informer: 'col-span-2 lg:row-start-2',
    reviewsHeader: 'col-span-2 mt-4 lg:row-start-3 lg:mt-0 lg:mb-0',
    contentWrapper: 'flex w-full flex-col gap-6',
    footerButton:
      'bg-bg-items-white heading-s-bold mt-6 flex h-12 w-full cursor-pointer items-center justify-center gap-5 tracking-wider uppercase'
  }
});
